/**
 * Nivel "Dios" / Owner de la plataforma — versión de frontend (Fase 4.5 + SA7).
 *
 * Espejo de `backend/core/platform_owner.py`.
 *
 * - Owner: `platform_role === 'owner'` (Dios lo nombra).
 * - Dios: correo de respaldo + superadmin de dealider-system. Solo Sergio.
 *   Nombra Owners. Un Owner no puede crearse un segundo Dios.
 *
 * IMPORTANTE: esto es solo para DECIDIR QUÉ MOSTRAR. La autorización real vive
 * en el backend (`require_platform_owner` / `require_dios` / `require_sa_perm`).
 */
const CORREOS_DUENO_RESPALDO = [
  'scastaneda@dragontec.net',
];

const EMPRESA_PLATAFORMA = 'dealider-system';

export function isDios(user) {
  if (!user) return false;
  const correo = String(user.email || '').trim().toLowerCase();
  return (
    CORREOS_DUENO_RESPALDO.includes(correo) &&
    user.role === 'superadmin' &&
    user.company_id === EMPRESA_PLATAFORMA
  );
}

export function isPlatformOwner(user) {
  if (!user) return false;
  if (user.platform_role === 'owner') return true;
  return isDios(user);
}

export default isPlatformOwner;
